import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BannerErrorContextProvider } from './BannerErrorContext';
import { IBannerErrorContextProps } from './BannerErrorContext.types';

export const ConnectedBannerErrorContextProvider: React.FC<IBannerErrorContextProps> = props => {
  const { t } = useTranslation();

  return <BannerErrorContextProvider {...props} t={t} />;
};
